import { themeColors } from '../../theme.config.js';

/**
 * Injects colors from theme.config.js into CSS variables on startup and HMR.
 * Changing theme.config.js will automatically update the entire application!
 */
export function applyThemeVariables() {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;

  if (themeColors.accent) {
    root.style.setProperty('--app-accent', themeColors.accent.primary);
    root.style.setProperty('--app-accent-hover', themeColors.accent.primaryHover);
    root.style.setProperty('--app-accent-text', themeColors.accent.primaryText || '#0f172a');
    root.style.setProperty('--app-accent-border', themeColors.accent.primaryBorder || themeColors.accent.primaryHover);
  }
}

export { themeColors };
export default themeColors;
